<template>
  <a-drawer
    title="修改密码"
    :width="720"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
  >
    <div>
      <a-table
        ref="table"
        :columns="columns"
        :dataSource="plmList"
        :row-key="(record) => record.Id"
        :loading="loading"
        style="border-radius: 0px"
        :bordered="false"
      >
        <template #operator class="table-operator"> </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a @click="articlePlm(record)">{{ $t("index.look") }}</a>
            <a-divider type="vertical" />
            <a @click="downloadPlm(record)">{{ $t("index.download") }}</a>
          </template>
        </template>
      </a-table>
    </div>

    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="onClose">Cancel</a-button>
    </div>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t } = useI18n();

const visible = ref(false);
const loading = ref(false);
const plmList = ref([]);
const FileType = ref("");
const OrderNumber = ref("");
const columns = [
  {
    title: t("index.knowledgetb1"),
    dataIndex: "title",
  },
  {
    title: t("index.knowledgetb5"),
    dataIndex: "action",
    align: "center",
  },
];

const onClose = () => {
  visible.value = false;
};

//打开抽屉
const onOpen = (id, orderNumber) => {
  OrderNumber.value = orderNumber;
  FileType.value = id;
  visible.value = true;
  plmPdfList();
};

//从plm中搜索
function plmPdfList() {
  loading.value = true;
  let params = {
    OrderNumber: OrderNumber.value,
    FileType: FileType.value,
  };
  //   return new Promise((resolve, reject) => {
  axios
    .post("api/RandomCenter/GetPLMRandomFile", params)
    .then((response) => {
      loading.value = false;
      if (response.data.code != 200) {
        if (response.data.info != "暂无数据") {
          //   reject(response.data.info);
          plmList.value = [];
          message.error(response.data.info);
        }
      } else {
        if (!response.data.ReturnData) {
          plmList.value = [];
          //   reject(t("service.noData"));
          //从bodor+中查
          if (FileType.value == "其他") {
            pdfList();
          }
        } else {
          //   resolve(response.data.ReturnData);
          if (response.data.ReturnData.length > 0) {
            plmList.value = response.data.ReturnData;
          } else {
            plmList.value = [];
            //从bodor+中查
            if (FileType.value == "其他") {
              pdfList();
            }
          }
        }
      }
    })
    .catch((err) => {
      plmList.value = [];
      loading.value = false;
    });
  //   });
}

//从bodor+中查找
function pdfList() {
  loading.value = true;
  let params = {
    OrderNumber: OrderNumber.value,
    EquipmentId: "",
  };
  axios
    .post("api/Machine/GetEquipmetFileData", params)
    .then((response) => {
      loading.value = false;
      if (response.data.code == 200 && response.data.ReturnType) {
        plmList.value = response.data.ReturnData;
      } else {
        plmList.value = [];
        message.error(response.data.info);
      }
    })
    .catch((err) => {
      plmList.value = [];
    });
}

//点击查看文件
const articlePlm = (record) => {
  window.open(record.webpath + record.filepath);
};

//点击下载文件
const downloadPlm = (record) => {
  let url = "https://apicloud.bodor.com" + record.filepath;
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      if (record.filepath.split("/")[1] == "Areas") {
        link.href = "https://apicloud.bodor.com" + record.filepath;
      } else {
        link.href = "https://apicloud.bodor.com/wwwroot" + record.filepath;
      }

      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口

      link.setAttribute("download", record.title);
      link.setAttribute("target", "_blank");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    }
  };
  xhr.send();
};

defineExpose({
  onOpen,
});
</script>
<style scoped>
.menu {
  width: 20%;
  height: 100%;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.inner {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  padding: 0px 2% 0px 0px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.tab {
  width: 78%;
}
a {
  color: #1890ff;
}
</style>
